// extracted by mini-css-extract-plugin
export default {"img":"Admin_img__yoK+x","cardconteiner":"Admin_cardconteiner__rJKGp","btn":"Admin_btn__ZNFYZ","btndelete":"Admin_btndelete__w4S37"};